import React, { Suspense, useState } from 'react'
import ReactDOM from 'react-dom'

import CastProvider from 'react-chromecast'
import { Provider } from 'react-redux'
import Notifications from 'react-notify-toast'
import { CookiesProvider } from 'react-cookie'
import {
  createMemorySource,
  createHistory,
  LocationProvider,
} from '@reach/router'

import App from './App'
import { store, persistor } from './store/configureStore'
import { register, unregister } from './serviceWorker'

// custom styles
import './components/theme/custom.scss'
import './styles/customStyles.scss'

import './i18n'

register()
if (
  window.location.protocol !== 'https:' &&
  !window.location.origin.includes('localhost')
) {
  window.location.replace(
    `https:${window.location.href.substring(window.location.protocol.length)}`
  )
}
// let history = createHistory(window)
let source = createMemorySource('/')
let history = createHistory(source)

window.location.href = 'https://webmiazga.app/zaloguj'

// const initializeCastApi = () => {
//   window.cast.framework.CastContext.getInstance().setOptions({
//     receiverApplicationId: '96BA8A62',
//     autoJoinPolicy: window.chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
//   })
// }

// window['__onGCastApiAvailable'] = function (isAvailable) {
//   if (isAvailable) {
//     setTimeout(() => {
//       initializeCastApi()
//     }, 200)
//   } else {
//     initializeCastApi()
//   }
// }

ReactDOM.render(
  <CookiesProvider>
    <LocationProvider history={history}>
      <Provider store={store}>
        <Suspense fallback={null}>
          <CastProvider>
            <App />
          </CastProvider>
        </Suspense>

        <Notifications
          className="notification"
          options={{ zIndex: 111111, top: '20%' }}
        />
      </Provider>
    </LocationProvider>
  </CookiesProvider>,
  document.getElementById('root')
)
